<template>
  <div class="panel panel-default">
    <div class="panel-heading">
      <span style="font-weight: 700" class="text-uppercase">Beitragserweiterung {{ index + 1 }}</span>
      <div style="float:right">
        <button class="btn btn-sm btn-default" style="float:right; border: 0" @click="removeAdditionalContent"
                content="Beitragserweiterung löschen" v-tippy>
          <i class="fa fa-close" style="color: black"></i>
        </button>
      </div>
    </div>
    <div class="panel-body">
      <label for="">Beitragsbild</label>
      <a class="fa fa-question-circle" v-tippy
         content="Das empfohlene Bild- & Videomaß liegt im Seitenverhältnis 4:5 oder bei 1125x1452. Die maximale Dateigröße bei Videos beträgt 10 MB."></a>
      <content-preview-additional-content :additional-content="additionalContent"
                                          :scale-height="1452"
                                          :scale-width="1152"
                                          @update:channels="channelsUpdated">
      </content-preview-additional-content>
      <br>
      <div v-if="typeof additionalContent.image_url === 'string'
                                && !additionalContent.image_url.includes('.mov')
                                && !additionalContent.image_url.includes('.mp4')
                                && !additionalContent.image_url.includes('.webm')">
        <div v-for="(productMark,index) in additionalContent.product_marks">
          <magazine-product-mark :product-mark="productMark" :index="index"
                                 :additional-content="additionalContent">
          </magazine-product-mark>
        </div>
        <div class="btn btn-success col-md-12" @click="addProductMark">
          <a class="fa fa-plus text-white"></a>&nbsp;Produktmarkierung hinzufügen
        </div>
      </div>
      <br>
      <div class="ckeditor-wrapper">
        <label style="margin-bottom: 10px" for="">Content</label>
        <a class="fa fa-question-circle" v-tippy
           content="Hier können alle Infos zum News Beitrag stehen. Außerdem können Links eingefügt werden."></a>
        <VueEditor ref="editor" v-model="additionalContent.text" :editor-toolbar="toolbar"></VueEditor>
      </div>
      <br>
    </div>
  </div>
</template>

<script>
import VueToastr from "vue-toastr";
import {mapGetters, mapMutations} from "vuex";
import MagazineProductMark from "./MagazineProductMark";
import ContentPreviewAdditionalContent from "../image/ContentPreviewAdditionalContent";
import {installSoftBreak} from "../editor/softBreak";
export default {
  name: 'MagazineAdditionalContent',
  components: {ContentPreviewAdditionalContent, VueToastr, MagazineProductMark},
  props: ['context', 'additionalContent', 'selections', 'newsHub', 'editorConfig', 'index', 'channel', 'channelIndex',
    'isos', 'languages', 'translations', 'mediaFiles', 'flagCdnUrl'],
  data() {
    return {
      toolbar: [
        [{header: [false, 1, 2, 3, 4, 5, 6]}],
        ["bold", "italic", "underline", "strike"], // toggled buttons
        [
          {align: ""},
          {align: "center"},
          {align: "right"},
          {align: "justify"}
        ],
        ["blockquote"],
        [{list: "ordered"}, {list: "bullet"}, {list: "check"}],
        [{indent: "-1"}, {indent: "+1"}],
        [{color: []}, {background: []}],
        ["link", "image", "clean"]
      ]
    }
  },
  computed: {
    ...mapGetters({
      internalLinks: 'getInternalLinks'
    }),
  },
  mounted() {
    this.$nextTick(() => {
      installSoftBreak(this.$refs.editor.quill, (clean) => {
        this.additionalContent.text = clean;
      });
    });
  },
  methods: {
    channelsUpdated() {
      this.$parent.$forceUpdate()
    },
    ...mapMutations(['getChannels']),
    removeAdditionalContent() {
      this.channel.additional_content.splice(this.index, 1);
    },
    async addProductMark() {
      this.additionalContent.product_marks.push({
        title: '',
        text: '',
        x: 200.0,
        y: 200.0,
        relative_x: 200.0,
        relative_y: 200.0,
        use_button: false,
        media_src: null,
        button_text: 'Hier klicken',
        link_type: 'internal',
        link_internal: Object.keys(this.internalLinks)[0],
        link_external: '',
        atom_id: null
      });
      this.channelsUpdated();
      this.$parent.$forceUpdate();
    }
  }
}
</script>

<style scoped>
.flex-column {
  display: flex;
  flex-direction: column;
}
</style>
<style>
.ckeditor-wrapper-app .ck-content {
  min-height: 100px;
  margin-top: 10px;
}
</style>
